type ImageCategory = 'tokens' | 'protocols' | 'networks' | 'curators'

const protocolOverrides: Record<string, string> = {
  'ether.fi': 'etherfi',
  'inverse finance': 'inverse',
  'open eden': 'openeden',
  'overnight finance': 'overnight',
  'rocket pool': 'rocketPool',
  'revert.finance': 'revertFinance',
  'summer.fi': 'summerfi',
  'harvest finance': 'harvest',
  aera: 'gauntlet',
  'upshift finance': 'upshift',
  'vaults.fyi': 'vaultsfyi',
}

function normalizeProtocolName(name: string): string {
  return protocolOverrides[name.toLowerCase()] ?? name
}

function normalizeCuratorName(name: string): string {
  return name.toLowerCase().replace(/[ .]/g, '-')
}

function normalizeTokenSymbol(symbol: string): string {
  return symbol.toLowerCase()
}

function normalizeNetworkName(name: string): string {
  return name
}

export function normalizeImageName(category: ImageCategory, name: string): string {
  switch (category) {
    case 'tokens':
      return normalizeTokenSymbol(name)
    case 'protocols':
      return normalizeProtocolName(name)
    case 'networks':
      return normalizeNetworkName(name)
    case 'curators':
      return normalizeCuratorName(name)
  }
}
